import type { LeadFormOtpLeadType } from "../../types/types";

const STORAGE_PREFIX = "agilis:lead-otp-pending";
const PENDING_TTL_MS = 30 * 60 * 1000;

type StoredPendingPayload = {
  payload: Record<string, unknown>;
  savedAt: number;
};

export function getPendingPayloadKey(
  storefrontId: string,
  leadType: LeadFormOtpLeadType
): string {
  return `${STORAGE_PREFIX}:${storefrontId}:${leadType}`;
}

export function savePendingPayload(
  storefrontId: string,
  leadType: LeadFormOtpLeadType,
  payload: Record<string, unknown>
): void {
  const entry: StoredPendingPayload = {
    payload,
    savedAt: Date.now(),
  };
  sessionStorage.setItem(
    getPendingPayloadKey(storefrontId, leadType),
    JSON.stringify(entry)
  );
}

export function loadPendingPayload(
  storefrontId: string,
  leadType: LeadFormOtpLeadType
): Record<string, unknown> | null {
  const raw = sessionStorage.getItem(
    getPendingPayloadKey(storefrontId, leadType)
  );
  if (!raw) {
    return null;
  }
  try {
    const entry = JSON.parse(raw) as StoredPendingPayload;
    if (Date.now() - entry.savedAt > PENDING_TTL_MS) {
      clearPendingPayload(storefrontId, leadType);
      return null;
    }
    return entry.payload;
  } catch {
    clearPendingPayload(storefrontId, leadType);
    return null;
  }
}

export function clearPendingPayload(
  storefrontId: string,
  leadType: LeadFormOtpLeadType
): void {
  sessionStorage.removeItem(getPendingPayloadKey(storefrontId, leadType));
}
